import { all, fork } from 'redux-saga/effects'

import usuario from './usuario'

export default function* root() {
  yield all([
    fork(usuario),
  ])
}